import { ReactElement, useMemo } from "react";
import classNames from "classnames";
import styles from "./svgIcon.module.less";
import { never } from "client_legacy/ndaw/errors";
import { isNil, setTrackingId } from "client/Misc/utils";

export type FontIconName =
	| "the-hub"
	| "workspace"
	| "column-add-left"
	| "column-add-right"
	| "column-delete"
	| "address-book"
	| "layer-xmark"
	| "layer-plus-check"
	| "row-add-bottom"
	| "row-add-top"
	| "row-delete"
	| "ms-sharepoint"
	| "ms-teams"
	| "thumbtack"
	| "bold"
	| "zoom"
	| "join-me"
	| "address-card"
	| "align-center"
	| "align-justify"
	| "align-left"
	| "align-right"
	| "angles-left"
	| "angles-right"
	| "arrow-down"
	| "arrow-down-left-and-arrow-up-right-to-center"
	| "arrow-left"
	| "arrow-left-to-line"
	| "arrow-right"
	| "arrow-right-from-bracket"
	| "arrow-right-to-bracket"
	| "arrow-right-to-line"
	| "arrow-rotate-left"
	| "arrow-rotate-right"
	| "arrows-rotate"
	| "arrows-up-down-left-right"
	| "arrow-up"
	| "arrow-up-right-and-arrow-down-left-from-center"
	| "arrow-up-right-from-square"
	| "at"
	| "ban"
	| "bars"
	| "bell"
	| "bell-slash"
	| "newspaper"
	| "box-archive"
	| "briefcase"
	| "buildings"
	| "bullhorn"
	| "calendar"
	| "calendar-day"
	| "calendar-week"
	| "camera"
	| "check"
	| "chevron-down"
	| "chevron-left"
	| "chevron-right"
	| "chevron-up"
	| "circle-check"
	| "circle-half-stroke"
	| "circle-info"
	| "circle-question"
	| "circle-xmark"
	| "clock"
	| "clock-rotate-left"
	| "cloud"
	| "cloud-arrow-down"
	| "comment"
	| "compass"
	| "copy"
	| "credit-card"
	| "display"
	| "download"
	| "ellipsis"
	| "envelope"
	| "eye"
	| "eye-slash"
	| "feather"
	| "file"
	| "file-image"
	| "file-lines"
	| "file-music"
	| "file-video"
	| "file-zipper"
	| "filter"
	| "flag"
	| "floppy-disk"
	| "folder-open"
	| "gear"
	| "gift"
	| "globe"
	| "graduation-cap"
	| "grid-2"
	| "grid-2-plus"
	| "grip-dots-vertical"
	| "grip-lines"
	| "heart"
	| "house"
	| "indent"
	| "italic"
	| "key"
	| "layer-group"
	| "link"
	| "link-slash"
	| "list"
	| "list-ol"
	| "location-dot"
	| "lock"
	| "magnifying-glass"
	| "masks-theater"
	| "minus"
	| "mobile-notch"
	| "outdent"
	| "paperclip"
	| "paper-plane"
	| "paragraph"
	| "pen"
	| "phone"
	| "piggy-bank"
	| "plus"
	| "print"
	| "question"
	| "reply"
	| "reply-all"
	| "rocket"
	| "screwdriver-wrench"
	| "server"
	| "share-from-square"
	| "shield-check"
	| "shield-xmark"
	| "sliders-simple"
	| "star"
	| "store"
	| "strikethrough"
	| "table-cells"
	| "underline"
	| "tag"
	| "text"
	| "thumbs-up"
	| "ticket"
	| "trash-can"
	| "triangle-exclamation"
	| "upload"
	| "user"
	| "user-check"
	| "user-group"
	| "user-lock"
	| "user-plus"
	| "user-tie"
	| "user-xmark"
	| "video"
	| "wifi"
	| "wrench"
	| "xmark"
	| "caret-down"
	| "flag-filled"
	| "heart-filled"
	| "play"
	| "star-filled"
	| "thumbs-up-filled"
	| "hand-pointer"
	| "calendar-circle-user"
	| "hourglass-end"
	| "syringe"
	| "image"
	| "briefcase-medical"
	| "share"
	| "coin-blank"
	| "book"
	| "arrows-left-right"
	| "arrow-left-and-arrow-right-to-center"
	| "arrow-left-and-arrow-right-from-center"
	| "bars-sort"
	| "objects-column"
	| "envelope-open"
	| "window-maximize"
	| "window-restore"
	| "calendar-update"
	| "cake-candles"
	| "chart-line"
	| "code"
	| "circle-pause"
	| "circle-play"
	| "arrow-up-arrow-down"
	| "eraser"
	| "brackets-curly"
	| "arrow-up-to-line"
	| "expand"
	| "function"
	| "file-export"
	| "adobe"
	| "google"
	| "windows8"
	| "brightness"
	| "car-side"
	| "coins"
	| "copyright"
	| "volume"
	| "window"
	| "users"
	| "egnyte"
	| "square"
	| "filter-circle-xmark"
	| "calendar-star"
	| "note-sticky"
	| "pen-to-square"
	| "map"
	| "sparkles"
	| "arrow-right-arrow-left"
	| "microphone"
	| "bars-progress"
	| "thumbs-down"
	| "palette"
	| "circle"
	| "face-smile"
	| "lightbulb-on"
	| "paw"
	| "pizza-slice"
	| "symbols"
	| "volleyball";

export type SvgIconName =
	| "celebrate"
	| "laugh"
	| "like"
	| "love"
	| "sad"
	| "thank"
	| "wave"
	| "party-popper"
	| "archive"
	| "calendar"
	| "csv"
	| "folder"
	| "create-folder"
	| "message"
	| "jpeg"
	| "png"
	| "gif"
	| "bmp"
	| "doc"
	| "docx"
	| "docm"
	| "dotx"
	| "dotm"
	| "visio"
	| "xls"
	| "xlsx"
	| "xlsm"
	| "powerpoint"
	| "pptm"
	| "onenote"
	| "file"
	| "text"
	| "pdf"
	| "create-word"
	| "create-excel"
	| "create-powerpoint"
	| "create-onenote"
	| "flag-australia"
	| "flag-denmark"
	| "flag-france"
	| "flag-germany"
	| "flag-great-britain"
	| "flag-italy"
	| "flag-netherlands"
	| "flag-new-zealand"
	| "flag-norway"
	| "flag-spain"
	| "flag-sweden"
	| "flag-united-states"
	| "ms-sharepoint"
	| "ms-teams";

export type IconColor =
	| "primary"
	| "primary-contrast"
	| "secondary"
	| "info"
	| "success"
	| "warning"
	| "danger"
	| "purple"
	| "cyan"
	| "primary-text"
	| "bookmark"
	| "header"
	| "white"
	| "default-skin-color"
	| "light-skin-color"
	| "medium-light-skin-color"
	| "medium-skin-color"
	| "medium-dark-skin-color"
	| "dark-skin-color"
	| "app";

export type IconSize =
	|"default"
	| "extra-extra-large"
	| "extra-large"
	| "large"
	| "medium"
	| "small"
	| "extra-small";

export type FontIconValueWithColor = FontIconValue & { color?: IconColor; };

export type FontIconValue = {
	kind: "font";
	name: FontIconName;
};

export type SvgIconValue = {
	kind: "svg";
	name: SvgIconName;
};

export type IconValue = FontIconName
	| FontIconValueWithColor
	| SvgIconValue;

export type IconProps = {
	value: IconValue;
	size?: IconSize;
	tooltip?: string;
};

export const Icon = (props: IconProps): ReactElement => {
	const {
		value: valueFromProps,
		size = "default",
		tooltip
	} = props;

	const value: IconValue = useMemo(
		() => {
			let value: IconValue = valueFromProps;

			if (typeof value === "string") {
				value = {
					kind: "font",
					name: value
				};
			}

			return value;
		},
		[valueFromProps]
	);

	switch (value.kind) {
		case "font":
			return (
				<i
					{...setTrackingId(value.name)}
					className={classNames(
						iconKindToCssClass(value.name),
						{
							[`action-icon--${size}`]: size !== "default",
							[`action-icon--${value.color}`]: value.color,
						}
					)}
					title={tooltip}
					aria-label={tooltip}
					aria-hidden={isNil(tooltip)}
				/>
			);
		case "svg":
			return (
				<i
					{...setTrackingId(value.name)}
					className={classNames(
						styles.svgIcon,
						svgNameToStyleMap[value.name],
						iconSizeToSvgStyles[size]
					)}
					title={tooltip}
					aria-label={tooltip}
					aria-hidden={isNil(tooltip)}
				/>
			);
		default:
			never(value);
	}
};

Icon.displayName = "Icon";

export function iconKindToCssClass(
	icon: FontIconName | undefined | null
): string {
	if (!icon) {
		return "";
	}
	return `action-icon-${icon}`;
}

export const isSvgIcon = (icon: IconValue): icon is SvgIconValue => {
	return typeof icon !== "string"
		&& icon.kind === "svg";
};

export function unsetIconColor(icon: IconValue): IconValue {
	if (typeof icon === "string" || isSvgIcon(icon)) {
		return icon;
	}

	return icon.name;
}

const iconSizeToSvgStyles: { [key in IconSize]: string | undefined } = {
	["default"]: undefined,
	["extra-extra-large"]: styles.svgIcon_extraExtraLarge,
	["extra-large"]: styles.svgIcon_extraLarge,
	["large"]: styles.svgIcon_large,
	["medium"]: styles.svgIcon_medium,
	["small"]: styles.svgIcon_small,
	["extra-small"]: styles.svgIcon_extraSmall,
};

const svgNameToStyleMap: Record<SvgIconName, string> = {
	["celebrate"]: styles.svgIcon_celebrate,
	["laugh"]: styles.svgIcon_laugh,
	["like"]: styles.svgIcon_like,
	["love"]: styles.svgIcon_love,
	["sad"]: styles.svgIcon_sad,
	["thank"]: styles.svgIcon_thank,
	["wave"]: styles.svgIcon_wave,
	["party-popper"]: styles.svgIcon_partyPopper,
	["archive"]: styles.svgIcon_archive,
	["calendar"]: styles.svgIcon_calendar,
	["csv"]: styles.svgIcon_csv,
	["folder"]: styles.svgIcon_folder,
	["create-folder"]: styles.svgIcon_createFolder,
	["message"]: styles.svgIcon_message,
	["jpeg"]: styles.svgIcon_jpeg,
	["png"]: styles.svgIcon_png,
	["gif"]: styles.svgIcon_gif,
	["bmp"]: styles.svgIcon_bmp,
	["doc"]: styles.svgIcon_doc,
	["docx"]: styles.svgIcon_docx,
	["docm"]: styles.svgIcon_docm,
	["dotx"]: styles.svgIcon_dotx,
	["dotm"]: styles.svgIcon_dotm,
	["visio"]: styles.svgIcon_visio,
	["xls"]: styles.svgIcon_xls,
	["xlsx"]: styles.svgIcon_xlsx,
	["xlsm"]: styles.svgIcon_xlsm,
	["powerpoint"]: styles.svgIcon_powerpoint,
	["pptm"]: styles.svgIcon_pptm,
	["onenote"]: styles.svgIcon_onenote,
	["file"]: styles.svgIcon_file,
	["text"]: styles.svgIcon_text,
	["pdf"]: styles.svgIcon_pdf,
	["create-word"]: styles.svgIcon_createWord,
	["create-excel"]: styles.svgIcon_createExcel,
	["create-powerpoint"]: styles.svgIcon_createPowerpoint,
	["create-onenote"]: styles.svgIcon_createOnenote,
	["flag-australia"]: styles.svgIcon_flagAustralia,
	["flag-denmark"]: styles.svgIcon_flagDenmark,
	["flag-france"]: styles.svgIcon_flagFrance,
	["flag-germany"]: styles.svgIcon_FlagGermany,
	["flag-great-britain"]: styles.svgIcon_FlagGreatBritain,
	["flag-italy"]: styles.svgIcon_FlagItaly,
	["flag-netherlands"]: styles.svgIcon_FlagNetherlands,
	["flag-new-zealand"]: styles.svgIcon_FlagNewZealand,
	["flag-norway"]: styles.svgIcon_FlagNorway,
	["flag-spain"]: styles.svgIcon_FlagSpain,
	["flag-sweden"]: styles.svgIcon_FlagSweden,
	["flag-united-states"]: styles.svgIcon_FlagUnitedStates,
	["ms-sharepoint"]: styles.svgIcon_msSharepoint,
	["ms-teams"]: styles.svgIcon_msTeams
};
